
import FolderIcon from '@/components/Folders/Icons/FolderIcon'
import FileIcon from '@/components/Folders/Icons/FileIcon'
import QanoniahFileIcon from '@/components/Folders/Icons/QanoniahFileIcon'
import ContractIcon from '@/components/Folders/Icons/ContractIcon'
export default {
    name: 'FilesystemNodeIcon',
    components: { FolderIcon, QanoniahFileIcon, FileIcon, ContractIcon },
    props: {
        node: {
            type: Object,
            required: true
        }
    },
    computed: {
        iconName () {
            if (this.node.node_type === 'd') {
                return 'FolderIcon'
            }
            return this.node?.data?.icon || 'FileIcon'
        }
    }
}
